import {
  ShippingClaimSchema,
  shippingClaimUpdateSchema,
} from "@redotech/redo-model/shipping-claims/shipping-claim";
import * as z from "zod";

export const updateShippingClaim = {
  name: "updateShippingClaim" as const,
  input: shippingClaimUpdateSchema,
  output: z.object({ shippingClaim: ShippingClaimSchema }),
};
